import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { UsersIcon } from "@heroicons/react/24/outline";
import { UserCircleIcon, UserIcon } from "@heroicons/react/24/solid";
import { Link, NavLink } from "react-router-dom";

// Icons
import { ReactComponent as Profile } from "../../images/icons/profile.svg";
import { ReactComponent as Address } from "../../images/icons/location.svg";
import { ReactComponent as Security } from "../../images/icons/security-user.svg";
import { ReactComponent as Orders } from "../../images/icons/orders.svg";
import { ReactComponent as Payments } from "../../images/icons/payments.svg";
import { ReactComponent as ZulalCredits } from "../../images/icons/credits.svg";
import { ReactComponent as Logoff } from "../../images/icons/logout.svg";

import { useContext } from "react";
import { UserContext } from "../../context/user.context";
import { useState } from "react";

import {
  UilCreateDashboard,
  UilUser,
  UilShieldCheck,
  UilUserLocation,
  UilShoppingCart,
  UilInvoice,
  UilWallet,
  UilSignout,
  UilCreditCard,
  UilBill,
  UilCommentAltEdit,
  UilTruck,
} from "@iconscout/react-unicons";

import NavData from "../../utils/Data/UserNavData.json";

import UiMosque from "../../utils/icons/UiMosque";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function UserMenu() {
  const { currentUser } = useContext(UserContext);

  if (currentUser.isloggedIn === true) {
    return (
      <Menu as="div" className="inline-block text-left">
        <div>
          <Menu.Button className="flex items-center justify-center rounded-full bg-primary h-8 w-8 xl:w-10 xl:h-10 text-textWhite hover:bg-primaryHover focus:outline-none focus:ring-2 focus:ring-secondary">
            <UserIcon className="w-6 h-6" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            className="absolute right-4 z-10 mt-2 w-max-w-sm origin-top-right divide-y divide-cool-gray-300 rounded-md bg-textWhite 
                                  shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <div className="px-4 py-3">
              <p className="text-sm">Signed in as</p>
              <p className="truncate text-sm font-medium text-gray-900">
                {`${currentUser.outletName}!`}
              </p>
            </div>
            <div className="py-1">
              {NavData.map((item) => {
                // console.log(
                //   "TITLE:",
                //   JSON.stringify(item.title),
                //   "ICON:",
                //   JSON.stringify(item.icon)
                // );

                if (!item.active) return null;

                return (
                  <NavLink
                    key={item.path}
                    to={`../user/${item.path}`}
                    state={{ PageTitle: item.title }}
                    className={classNames(
                      "flex flex-row items-center px-4 py-1 text-base gap-2 font-poppins hover:text-primary",
                      item.active ? "text-primaryHover" : "text-primary"
                    )}
                  >
                    {item.title === "Dashboard" ? (
                      <UilCreateDashboard className="text-primary" />
                    ) : item.title === "Profile" ? (
                      <UilUser className="text-primary" />
                    ) : item.title === "Address Book" ? (
                      <UilUserLocation className="text-primary" />
                    ) : item.title === "Security" ? (
                      <UilShieldCheck className="text-primary" />
                    ) : item.title === "Zulal Wallet" ? (
                      <UilWallet className="text-primary" />
                    ) : item.title === "Orders" ? (
                      <UilShoppingCart className="text-primary" />
                    ) : item.title === "Partial Deliveries" ? (
                      <UilTruck className="text-primary" />
                    ) : item.title === "Invoices" ? (
                      <UilInvoice className="text-primary" />
                    ) : item.title === "Payments" ? (
                      <UilBill className="text-primary" />
                    ) : item.title === "Mosque Orders" ? (
                      <UiMosque className="text-primary" fillColor="#3F95A9" />
                    ) : item.title === "Partners Card" ? (
                      <UilCreditCard className="text-primary" />
                    ) : item.title === "Suggestion / Complaints" ? (
                      <UilCommentAltEdit className="text-primary" />
                    ) : item.title === "Log Out" ? (
                      <UilSignout className="text-primary" />
                    ) : (
                      <span className="text-red-500">NO ICON</span>
                    )}

                    {item.title}
                  </NavLink>
                );
              })}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    );
  } else {
    return (
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button
            as={NavLink}
            to="/login"
            onClick={() => {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            className="flex items-center justify-center rounded-full bg-darkLight h-8 w-8 xl:w-10 xl:h-10 text-textWhite hover:bg-darkHover focus:outline-none focus:ring-2 focus:ring-darkVeryLight"
          >
            <UserIcon className="w-6 h-6" />
          </Menu.Button>
        </div>
      </Menu>
    );
  }
}
